// extracted by mini-css-extract-plugin
module.exports = {"question-container":"style_question-container__rIe1I","question-header-container":"style_question-header-container__hZyVo","chevron-animation":"style_chevron-animation__rrNY1"};